// Muestra los componentes FIJOS de un kit predefinido (Cerraduras PREMIUM).
// A diferencia de KitVinculo, no hay que vincular nada: los componentes ya están
// definidos en categoriasOverride.js. Resuelve el NOMBRE de cada componente del
// catálogo (por código) para no mostrar códigos.

import React, { useEffect, useState } from "react";
import { componentesKitPredefinido } from "../services/categoriasOverride";
import { getCatalogoByCodUru } from "../services/catalogo";

export default function KitComponentesFijos({ codigoKit, cantKit = 1 }) {
  const comps = componentesKitPredefinido(codigoKit);
  const [nombres, setNombres] = useState({});

  useEffect(() => {
    if (!comps) return;
    let cancel = false;
    (async () => {
      const entries = await Promise.all(comps.map(async (c) => {
        let cat = null;
        try { cat = await getCatalogoByCodUru(c.cod); } catch { /* sin catálogo */ }
        return [c.cod, cat?.customerNo || cat?.descripcion || c.cod];
      }));
      if (!cancel) setNombres(Object.fromEntries(entries));
    })();
    return () => { cancel = true; };
  }, [codigoKit]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!comps) return null;
  const mult = Math.max(1, Number(cantKit) || 1);

  return (
    <div style={{ marginTop: "6px", background: "#faf5ff", border: "1.5px solid #e9d5ff", borderRadius: "10px", padding: "8px 10px" }}>
      <span style={{ display: "inline-block", fontSize: "0.68rem", fontWeight: 800, color: "#7c3aed", background: "#f3e8ff", padding: "2px 8px", borderRadius: "999px", marginBottom: "6px" }}>
        🧩 KIT — componentes
      </span>
      <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
        {comps.map((c, i) => (
          <div key={i} style={{ display: "flex", justifyContent: "space-between", gap: "10px", fontSize: "0.82rem" }}>
            <span style={{ color: "#334155", minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {nombres[c.cod] || c.cod}
            </span>
            <span style={{ flexShrink: 0, fontWeight: 700, color: "#7c3aed" }}>×{c.cant * mult}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
